export default __webpack_public_path__ + "media/images/bromley-4-871a09d4ad68622b1c23ddbb09ede7ce.png";